

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

// interface ingredients {
//     heading?: string;
//     subheading?: string;
//     para?: string;
//     items: ListItem[];
// }

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}
interface injectionList {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    injectionList: injectionList;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const lipotropic: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "lipotropic-injections",
        "meta": {
            "title": "Lipotropic Injections in Dubai | Elite Body Home",
            "description": "Boost fat-loss results and metabolism with our lipotropic injections containing vitamins, amino acids and minerals that help metabolize fat in the body.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/lipotropic-injections/",
            "og": {
                "title": "Lipotropic Injections in Dubai | Elite Body Home",
                "description": "Non-surgical fat reduction injections to boost metabolism and aid in fat breakdown",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-50.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Lipotropic Injections"],
        "hero": {
            "title": "Lipotropic Injections in Dubai",
            "subtitle": "Fat-Boosting Metabolism Therapy",
            "description": "Among the most popular non-surgical approaches to increase fat-loss results and metabolism are lipotropic injections. Fat Destroyer key ingredient in the vitamins, amino acids and minerals, which help to metabolize fat in the body. They now represent a popular choice for people looking to jumpstart weight loss alongside a healthy diet and exercise routine."
        },
        "injectionList": {
            "heading": "We offer various types of weight loss injections",
            "subheading": "Tailored to individual needs and goals",
            "items": [
                {
                    "title": "Fat Burning Injections",
                    "desc": "Targeted at areas where fat is stubborn like the abdomen, thighs and arms. The injections boost metabolism and aid in the breakdown of fat cells which are subsequently expelled from the body naturally.",
                    icon: "fa-solid fa-fire",
                },
                {
                    "title": "Aqualyx Fat Dissolving",
                    "desc": "A non-invasive fat reduction procedure that helps to dissolve fat in unwanted places, be it the chin, thighs, belly or abdomen. This facial injection uses deoxycholic acid to destroy fat cells, resulting in a more sculpted look.",
                    icon: "fa-solid fa-droplet",
                },
                {
                    "title": "Weight Loss Injections",
                    "desc": "An effective solution for those looking to lose weight quickly. These revolutionary treatments increase your metabolism, decrease appetite, and enhance fat loss–all of which helps facilitate the natural functions of your body.",
                    icon: "fa-solid fa-syringe",
                },
                {
                    "title": "Mounjaro Injection",
                    "desc": "A state-of-art weight loss injection used to regulate blood sugar levels & facilitate weight loss by controlling hunger & enhancing metabolic processes. It is recommended for people with obesity or those with difficulty losing weight.",
                    icon: "fa-solid fa-dna",
                },
                {
                    "title": "Ozempic Injection",
                    "desc": "A once-weekly injectable prescription medication that is used to control blood sugar levels in adults with type 2 diabetes. It also assists in management of weight by suppressing appetites and aiding in healthy metabolism.",
                    icon: "fa-solid fa-prescription-bottle-medical",
                },
                {
                    "title": "Weight Loss IV",
                    "desc": "A specialized IV Drip with a combination of vitamins, minerals and amino acids to enhance metabolism and energize. This approach helps the body better burn fat while addressing the right nutrients necessary to maintain general well being during a weight-loss program.",
                    icon: "fa-solid fa-vial",
                }
            ]
        },
        "howItWorks": {
            "title": "How Do Lipotropic Injections Work?",
            "description": "Knowing how lipotropic injections work will give you a better understanding as to why they're effective for fat loss and energy boost."
        },
        "procedureSteps": {
            "heading": "Procedure Overview",
            "para": "Lipotropic injections are composed of a mix of fat-burning components and the procedure is quick & minimally invasive:",
            "steps": [
                {
                    "title": "Methionine",
                    "desc": "An essential amino acid that aids the liver in processing fat and toxins.",
                    "icon": "fa-solid fa-dna"
                },
                {
                    "title": "Inositol",
                    "desc": "Helps in fat metabolism and lowers cholesterol levels.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "Choline",
                    "desc": "Aids in liver function and assists in fat breakdown.",
                    "icon": "fa-solid fa-filter"
                },
                {
                    "title": "Vitamin B12",
                    "desc": "Increases energy and Metabolism.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Quick Process",
                    "desc": "The injection takes a few minutes and can be done weekly or every two weeks with no anesthesia or recovery time.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Lipotropic Injections",
            "subheading": "Effective fat-burning and metabolism boosting",
            "para": "Lipotropic injections have many advantages in the process of losing weight and keeping your body healthy:",
            "items": [
                {
                    "title": "Enhanced Fat Metabolism",
                    "desc": "Contains amino acids and vitamins that help your body break down and burn fat more effectively.",
                    "icon": "fa-solid fa-fire"
                },
                {
                    "title": "Boosted Energy Levels",
                    "desc": "Vitamin B12 provides a burst of energy, making it easier to remain active.",
                    "icon": "fa-solid fa-battery-full"
                },
                {
                    "title": "Improved Liver Function",
                    "desc": "Detoxifies and protects the liver, powerfully helping fat metabolism.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "Supports Weight Loss",
                    "desc": "When combined with diet and exercise, these injections can speed up the weight-loss process.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "Overall Wellness",
                    "desc": "Promotes increased mental clarity, immune support, and general well-being.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "eligibility": {
            "heading": "Who Can Benefit from Lipotropic Injections?",
            "subheading": "",
            "para": "Lipotropic injections are not for every person, but they can be beneficial for:",
            "items": [
                {
                    "title": "Those Wanting to Burn Fat",
                    "desc": "Ideal for people wanting to shed trouble spots of fat while undergoing a diet and exercise regime.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "Vitamin Deficient Individuals",
                    "desc": "Beneficial for people deficient in vitamins, particularly B12.",
                    "icon": "fa-solid fa-vitamins"
                },
                {
                    "title": "Generally Healthy People",
                    "desc": "You should be in good general health without serious liver, kidney or heart problems.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation Before Your Treatment",
            "subheading": "",
            "para": "Lipotropic injections require some preparation to get the most out of them:",
            "items": [
                {
                    "title": "Medical Consultation",
                    "desc": "Consult with a qualified health professional before beginning lipotropic injections.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "Balanced Diet",
                    "desc": "Include lean proteins, fruits, vegetables, and healthy fats into your diet.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Better hydration helps metabolize and excrete fat more effectively.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Regular Exercise",
                    "desc": "Enhance fat burning and contribute to your weight loss efforts.",
                    "icon": "fa-solid fa-running"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "",
            "para": "When used with a nutrition-based weight management plan, lipotropic injections can yield visible results:",
            "items": [
                {
                    "title": "Gradual Fat Loss",
                    "desc": "A few weeks of consistent use will show results, with gradual fat loss over time.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "Improved Energy",
                    "desc": "The energy kick from B12 and other nutrients can sometimes be felt within hours.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Better Metabolic Function",
                    "desc": "Fats more effectively broken down and liver function improved for long-term fat burning.",
                    "icon": "fa-solid fa-fire"
                },
                {
                    "title": "Overall Wellness",
                    "desc": "Promotes increased mental clarity, immune support, and general well-being.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Recommendations",
            "subheading": "",
            "para": "To maximize and maintain the benefits of your lipotropic injections:",
            "items": [
                {
                    "title": "Maintain Healthy Lifestyle",
                    "desc": "Continue with balanced diet and regular exercise routine.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Drink plenty of water to support fat metabolism.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Follow Treatment Schedule",
                    "desc": "Regular injections as recommended for sustained results.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "Monitor Progress",
                    "desc": "Track your fat loss and energy level improvements.",
                    "icon": "fa-solid fa-chart-line"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Are lipotropic injections safe?",
                    "answer": "Yes, when administered by a licensed professional, lipotropic injections are safe. The ingredients are naturally occurring in the body and do not typically cause adverse reactions."
                },
                {
                    "question": "How soon can I see results?",
                    "answer": "Results vary, but many individuals begin to notice changes in their energy levels and fat loss within a few weeks. However, results improve when combined with diet and exercise."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Some mild side effects may include slight discomfort at the injection site, digestive issues, or allergic reactions. These are rare and usually resolve quickly."
                },
                {
                    "question": "Can I use lipotropic injections alone to lose weight?",
                    "answer": "Lipotropic injections are designed to support weight loss, but they are most effective when paired with a healthy diet and regular exercise."
                },
                {
                    "question": "How often should I get lipotropic injections?",
                    "answer": "Typically, lipotropic injections are administered weekly or every two weeks for optimal results."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/04-Lipotropic-Injections.jpg",
            "beforeAfter": [
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/103.webp",
                    alt: "Before After Image 103",
                },
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/104.webp",
                    alt: "Before After Image 104",
                },
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/102.webp",
                    alt: "Before After Image 102",
                },
            ],
        },
        "product": {
            "id": 7,
            "title": "Lipotropic Injections in Dubai",
            "description": "Fat-burning injections containing vitamins, amino acids and minerals that help metabolize fat in the body.",
            "price": 599
        }
    },
    "ar": {
        "url": "lipotropic-injections",
        "meta": {
            "title": "إبر ليبوتروبيك في دبي | ايليت بودي هوم",
            "description": "إبر حرق الدهون غير الجراحية لتعزيز عملية الأيض ومساعدة الجسم على تكسير الدهون بشكل أكثر فعالية.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/lipotropic-injections",
            "og": {
                "title": "إبر ليبوتروبيك في دبي | ايليت بودي هوم",
                "description": "إبر غير جراحية لحرق الدهون وتعزيز عملية التمثيل الغذائي",
                "image": "https://www.elitebodyhome.com/images/lipotropic-injections-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "إبر ليبوتروبيك"],
        "hero": {
            "title": "إبر ليبوتروبيك (الموجهة للدهون)",
            "subtitle": "علاج تعزيز التمثيل الغذائي وحرق الدهون",
            "description": "يُعد خيار غير جراحي شائع لتعزيز نتائج خسارة الدهون وزيادة معدل الأيض. تحتوي إبر ليبوتروبيك على مزيج من الفيتامينات، والأحماض الأمينية، والمعادن التي تعمل على دعم عملية تحلل الدهون داخل الجسم. وهي أكثر الطرق غير الجراحية شهرةً لمن يسعى إلى إنقاص الوزن بطريقة فعالة وآمنة، خصوصًا عند دمجها مع نظام غذائي صحي وبرنامج تمارين منتظم."
        },
        "injectionList": {
            "heading": "نقدم مجموعة متنوعة من إبر إنقاص الوزن",
            "subheading": "مصممة خصيصًا لتلائم احتياجاتك وأهدافك الفردية",
            "items": [
                {
                    "title": "إبر حرق الدهون",
                    "desc": "تُركز هذه الإبر على المناطق التي يصعب التخلص من الدهون المتراكمة بها مثل الأرداف والذراعين، حيث تُعزز من معدل الأيض وتساعد على تكسير الخلايا الدهنية.",
                    icon: "fa-solid fa-fire",
                },
                {
                    "title": "إبر أكواليكس لإذابة الدهون",
                    "desc": "تُعد إبر إذابة الدهون من أحدث طرق العلاج غير الجراحية لتقليل الدهون الموضعية، حيث تستهدف الدهون العنيدة في مناطق مثل الذقن، أو الفخذين، أو البطن.",
                    icon: "fa-solid fa-droplet",
                },
                {
                    "title": "إبر إنقاص الوزن",
                    "desc": "تُعد من الحلول الحديثة والفعالة لمن يرغب في التخلص من الوزن الزائد سريعًا، حيث تعمل هذه الإبر على تعزيز معدل الأيض، وكبح الشهية، وتحفيز حرق الدهون.",
                    icon: "fa-solid fa-syringe",
                },
                {
                    "title": "إبرة مونجارو",
                    "desc": "يُعد مونجارو من الإبر المتطورة المستخدمة في دبي للمساعدة على فقدان الوزن وتنظيم مستويات السكر في الدم. يساهم في السيطرة على الشهية وتحفيز عمليات التمثيل الغذائي.",
                    icon: "fa-solid fa-dna",
                },
                {
                    "title": "إبرة أوزمبيك",
                    "desc": "أوزمبيك هو دواء يُحقن مرة أسبوعيًا، يُستخدم بشكل أساسي لضبط مستويات السكر في الدم لدى البالغين المصابين بالسكري من النوع الثاني. كما يُساعد على التحكم في الشهية وتحسين عملية التمثيل الغذائي.",
                    icon: "fa-solid fa-prescription-bottle-medical",
                },
                {
                    "title": "العلاج الوريدي لإنقاص الوزن",
                    "desc": "علاج التنقيط الوريدي المتخصص لإنقاص الوزن، يحتوي على مزيج فعّال من الفيتامينات والمعادن والأحماض الأمينية لتحفيز الأيض وتعزيز مستويات الطاقة.",
                    icon: "fa-solid fa-vial",
                }
            ]
        },
        "howItWorks": {
            "title": "كيف تعمل إبر ليبوتروبيك؟",
            "description": "يساعدك معرفة طريقة عمل إبر ليبوتروبيك على فهم سبب فعاليتها في خسارة الدهون وزيادة الطاقة."
        },
        "procedureSteps": {
            "heading": "خطوات الإجراء",
            "para": "تحتوي إبر ليبوتروبيك على مزيج من العناصر التي تحفز حرق الدهون وتدعم وظائف الكبد:",
            "steps": [
                {
                    "title": "الميثيونين",
                    "desc": "وهو حمض أميني أساسي يساعد الكبد على معالجة الدهون والتخلص من السموم.",
                    "icon": "fa-solid fa-dna"
                },
                {
                    "title": "الإينوزيتول",
                    "desc": "يساعد عملية التمثيل الغذائي للدهون ويعمل على تقليل مستويات الكوليسترول في الدم.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "الكولين",
                    "desc": "يدعم وظائف الكبد ويساعد على تكسير الدهون.",
                    "icon": "fa-solid fa-filter"
                },
                {
                    "title": "فيتامين ب 12",
                    "desc": "يساهم في تعزيز مستويات الطاقة وتحفيز عملية الأيض، ما يعزز النشاط البدني والذهني.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "إجراء سريع",
                    "desc": "يستغرق الحقن بضع دقائق فقط ويمكن تكرارها أسبوعيًا أو كل أسبوعين دون الحاجة لتخدير أو فترة تعافي.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد إبر ليبوتروبيك",
            "subheading": "حرق فعال للدهون وتعزيز عملية التمثيل الغذائي",
            "para": "توفر إبر ليبوتروبيك فوائد متعددة في رحلة إنقاص الوزن والحفاظ على صحة الجسم:",
            "items": [
                {
                    "title": "تعزيز عملية التمثيل الغذائي للدهون",
                    "desc": "تحتوي هذه الإبر على أحماض أمينية وفيتامينات تساعد الجسم على تكسير الدهون بكفاءة أعلى.",
                    "icon": "fa-solid fa-fire"
                },
                {
                    "title": "زيادة مستويات الطاقة",
                    "desc": "تمنح الجسم دفعة من النشاط والطاقة بفضل فيتامين ب 12، مما يساعدك على البقاء نشيطًا وحيويًا.",
                    "icon": "fa-solid fa-battery-full"
                },
                {
                    "title": "تحسين وظائف الكبد",
                    "desc": "تساعد المكونات الموجودة في الإبر على تنقية الكبد من السموم وتعزيز قدرته على التمثيل الغذائي للدهون.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "دعم فعال لخسارة الوزن",
                    "desc": "تساهم هذه الإبر عند دمجها مع تمارين رياضية ونظام غذائي متوازن في تسريع النتائج وتحقيق أهدافك في فقدان الوزن.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "تحسين الصحة العامة",
                    "desc": "بالإضافة إلى دعم خسارة الوزن، تساهم هذه الحقن في تحسين صفاء الذهن، ودعم جهاز المناعة، وزيادة الإحساس العام بالحيوية.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية للعلاج",
            "subheading": "",
            "para": "لا يناسب استخدام إبر ليبوتروبيك لجميع الحالات، لكن هناك فئات يمكن أن تستفيد منها بشكل فعال:",
            "items": [
                {
                    "title": "الأشخاص الذين يسعون لحرق الدهون",
                    "desc": "يُعد خيارًا مثاليًا للأشخاص الذين يرغبون في التخلص من مناطق الدهون العنيدة أثناء اتباعهم نظام غذائي وتمارين رياضية.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "الأشخاص الذين يعانون من نقص في الفيتامينات",
                    "desc": "يمكن أن تكون هذه الإبر مفيدة للأشخاص الذين يعانون من نقص في الفيتامينات، وخاصة فيتامين ب 12.",
                    "icon": "fa-solid fa-vitamins"
                },
                {
                    "title": "الأشخاص الذين يمتلكون صحة عامة جيدة",
                    "desc": "ينبغي أن يكون الشخص في حالة صحية جيدة، دون وجود مشكلات خطيرة في الكبد أو الكلى أو القلب.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد قبل الجلسة",
            "subheading": "",
            "para": "تتطلب حقن الليبوتروبيك بعض التحضيرات المسبقة لضمان تحقيق أقصى استفادة منها:",
            "items": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "يجب استشارة طبيب متخصص ومؤهل قبل بدء العلاج، مع تزويده بكامل تاريخك الصحي وأهدافك المتعلقة بخسارة الدهون.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "اتباع نظام غذائي متوازن",
                    "desc": "تناول الأطعمة الصحية مثل البروتينات الخالية من الدهون، والخضراوات، والفواكه، والدهون المفيدة يساهم في تعزيز فاعلية العلاج.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "يساعد شرب كميات كافية من الماء على حرق الدهون بشكل أفضل وطرد السموم.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "ممارسة التمارين الرياضية",
                    "desc": "يعزز ممارسة التمارين المنتظمة من عملية حرق الدهون ويساهم في زيادة فاعلية رحلتك لإنقاص الوزن.",
                    "icon": "fa-solid fa-running"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "يمكن تحقيق نتائج واضحة عند استخدام إبر ليبوتروبيك كجزء من خطة إدارة الوزن:",
            "items": [
                {
                    "title": "خسارة تدريجية للدهون",
                    "desc": "تبدأ الدهون في التناقص بشكل تدريجي خلال بضعة أسابيع مع الاستخدام المنتظم للإبر، ما يؤدي إلى تغيير ملحوظ في شكل الجسم.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "تعزيز مستويات الطاقة",
                    "desc": "يشعر البعض بزيادة في النشاط خلال ساعات من تلقي العلاج، بفضل احتوائه على فيتامين ب 12 وعناصر غذائية أخرى.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "تحسين وظيفة التمثيل الغذائي",
                    "desc": "تساعد الإبر على تكسير الدهون بكفاءة أكبر وتحسين أداء الكبد، مما يعزز عملية حرق الدهون على المدى الطويل.",
                    "icon": "fa-solid fa-fire"
                },
                {
                    "title": "تحسين الصحة العامة",
                    "desc": "بالإضافة إلى دعم خسارة الوزن، تساهم هذه الحقن في تحسين صفاء الذهن، ودعم جهاز المناعة، وزيادة الإحساس العام بالحيوية.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح ما بعد العلاج",
            "subheading": "",
            "para": "لتعزيز والحفاظ على فوائد إبر ليبوتروبيك:",
            "items": [
                {
                    "title": "الحفاظ على نمط حياة صحي",
                    "desc": "الاستمرار في اتباع نظام غذائي متوازن وروتين تمارين رياضية منتظم.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "شرب كميات كافية من الماء لدعم عملية التمثيل الغذائي للدهون.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "الالتزام بجدول العلاج",
                    "desc": "الحصول على الحقن بانتظام حسب التوصيات الطبية لضمان نتائج مستدامة.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "مراقبة التقدم",
                    "desc": "تتبع التغيرات في فقدان الدهون وتحسين مستويات الطاقة.",
                    "icon": "fa-solid fa-chart-line"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة المكررة",
            "subheading": "",
            "items": [
                {
                    "question": "هل إبر الليبوتروبيك آمنة؟",
                    "answer": "نعم، تُعد إبر الليبوتروبيك آمنة عند إعطائها من قبل مخصص معتمد. المكونات المستخدمة موجودة طبيعياً في الجسم، ونادراً ما تسبب تفاعلات سلبية."
                },
                {
                    "question": "متى يمكنني ملاحظة النتائج؟",
                    "answer": "تختلف النتائج من شخص لآخر، لكن يبدأ العديد من الأشخاص بملاحظة تغيرات في مستويات الطاقة وفقدان الدهون خلال بضعة أسابيع. وتتحسن النتائج بشكل ملحوظ عند دمج الإبر مع نظام غذائي صحي وممارسة التمارين الرياضية."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "قد تظهر بعض الآثار الجانبية الطفيفة مثل الشعور بعدم الراحة في موضع الحقن، أو مشكلات بسيطة في الجهاز الهضمي، أو ردود فعل تحسسية نادرة. غالبًا ما تكون هذه الأعراض مؤقتة وتزول سريعًا."
                },
                {
                    "question": "هل يمكنني الاعتماد على إبر الليبوتروبيك فقط لفقدان الوزن؟",
                    "answer": "تُصمم إبر الليبوتروبيك لدعم عملية فقدان الوزن، لكنها تكون أكثر فاعلية عند استخدامها كجزء من نمط حياة صحي يشمل التغذية المتوازنة والنشاط البدني المنتظم."
                },
                {
                    "question": "كم مرة يجب أن أحصل على إبر الليبوتروبيك؟",
                    "answer": "عادةً ما يتم إعطاء الإبر أسبوعيًا أو كل أسبوعين للحصول على أفضل النتائج."
                }
            ]
        }
    }
}